module.exports = __webpack_public_path__ + "static/media/Poppins-Light-devanagari.dc820d9f.woff2";